import React from 'react';
import PropTypes from 'prop-types';
import TicketItem from './TicketItem';

const TicketList = ({ title, tickets, type }) => (
  <div className={`recent-list ${type}`}>
    <h2>{title}</h2>
    {tickets.length > 0 ? (
      <ul>
        {tickets.map((ticket, index) => (
          <TicketItem key={`${type}-${index}`} {...ticket} />
        ))}
      </ul>
    ) : (
      <div className="no-data">Nenhum item disponível</div>
    )}
  </div>
);


TicketList.propTypes = {
  title: PropTypes.string.isRequired,
  tickets: PropTypes.array.isRequired,
  type: PropTypes.string
};

export default React.memo(TicketList);